import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { Constants } from 'src/app/core/constants/constants';
import { User } from 'src/app/core/models/user.model';
import { ParametrosService } from 'src/app/core/services/parametros.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { SubdominiosService } from 'src/app/core/services/dominios.service';
import { PaisesConstants } from 'src/app/core/constants/paises';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public activeOption = '';
  public showLogin = true;
  public showRegister = false;
  public showCompany = false;
  public showCompanyFields = false;
  public hidePass = true;
  public loginForm = null;
  public registerForm = null;
  public empresaForm = null;
  public action = '';
  public id_usuario = '662ab2d5-d74f-4949-88ec-56db83b985db';

  public creating = false;
  public error = null;
  public loginValue: string = null;
  public clave_usuario: string;
  public rememberMyUser = false;
  public verifyingLogin = false;
  public paises = PaisesConstants.countries.sort((a, b) => {
    const nameA = a.name_es.toUpperCase();
    const nameB = b.name_es.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });
  public listParams = null;
  public rol = null;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alertsService: AlertsService,
    private authService: AuthService,
    private router: Router,
    public dialogRef: MatDialogRef<LoginComponent>,
    private svParams: ParametrosService,
    private svUsuario: UsuarioService,
    private svSubdominios: SubdominiosService
  ) {
    this.action = data.action;
  }

  ngOnInit(): void {
    // this.getCountries();
    this.getParameters();
    this.loginForm = this.fb.group({
      correo_usuario: [null, [Validators.required]],
      clave_usuario: [null, [Validators.required]],
    });
    this.registerForm = this.fb.group({
      id_parametro_rol: [null, [Validators.required]],
      nombres_usuario: [null, [Validators.required]],
      apellidos_usuario: [null, [Validators.required]],
      correo_usuario: [null, [Validators.required]],
      telefono_usuario: [null, [Validators.required]],
      pais_usuario: [null, [Validators.required]],
      fecha_de_nacimiento_usuario: [null, [Validators.required]],
      clave_usuario: [null, [Validators.required]],
      confirmar_clave_usuario: [null, [Validators.required]],
      checkPolitics: [null, [Validators.required]],
    });
    this.empresaForm = this.fb.group({
      nombre_empresa_usuario: [null, [Validators.required]],
      correo_empresa_usuario: [null, [Validators.required]],
      telefono_empresa_usuario: [null, [Validators.required]],
      subdominio_empresa_usuario: [null, [Validators.required]],
      checkPolitics: [null, [Validators.required]],
      /* cuenta_activa_subdominio: [null, [Validators.required]], */
    });
    this.activeOption = this.action;

    if (this.action == 'login') {
      this.showLogin = true;
      this.showRegister = false;
    }
    if (this.action == 'register') {
      this.showRegister = true;
      this.showLogin = false;
    }
  }
  getParameters() {
    this.svParams.getTypeParameters().subscribe((reps) => {
      reps['body']['data'].filter((data) => {
        if (data['nombre_tipo_parametro'] === 'TIPO ROL') {
          this.svParams
            .getParameters(data['id_tipo_parametro'])
            .subscribe((rp) => {
              this.listParams = rp['body']['data'];
              this.listParams.filter((p) => {
                if (p['nombre_parametro'] == 'General') {
                  this.rol = p['id_parametro'];
                }
              });
            });
        }
      });
    });
  }

  loginUser(formValues) {
    this.verifyingLogin = true;

    if (formValues['correo_usuario'] != null) {
      const request = {
        correo_usuario: formValues['correo_usuario'],
        clave_usuario: formValues['clave_usuario'],
      };

      this.authService.login(request).subscribe(
        (data) => {
          if (data.status == 'success') {
            localStorage.setItem(
              Constants.ls.user,
              btoa(JSON.stringify(data['result']['user_data']))
            );
            localStorage.setItem(
              Constants.ls.at,
              btoa(JSON.stringify(data['result']['token']))
            );

            ///////
            this.svSubdominios.updateToken(
              btoa(JSON.stringify(data['result']['token']))
            );
            this.svUsuario.updateToken(
              btoa(JSON.stringify(data['result']['token']))
            );

            setTimeout(() => {
              this.verifyingLogin = false;
            }, 1000);
            this.alertsService.showSnackBar('Bienvenido al sistema...', 3000);
            this.dialogRef.close();
            if (localStorage.getItem('loginFromDemo') == 'true') {
              // this.router.navigate(['auth/start-demo']);
              window.location.href = 'auth/start-demo';
            } else {
              // this.router.navigate(['auth/home']);
              window.location.href = 'auth/home';
            }

            this.verifyingLogin = false;
          } else {
            Swal.fire('Error: Datos incorrectos', data.message, 'error');
          }
        },
        (err) => {
          this.verifyingLogin = false;
          Swal.fire(
            'Error: Inicio de sesión',
            'Algo salió mal al intentar iniciar sesión, intentelo más tarde',
            'error'
          );
        }
      );
    } else {
      this.verifyingLogin = false;
      Swal.fire(
        'Advertancia: ',
        'Por favor ingrese los datos de inicio de sesión',
        'warning'
      );
    }
  }
  registerUser(formValues) {
    if (formValues['clave_usuario'] !== formValues['confirmar_clave_usuario']) {
      Swal.fire('Advertancia: ', 'Las contraseñas no coinciden', 'warning');
      return;
    }
    if (!this.rol) {
      this.getParameters();
    }

    const request: User = {
      id_parametro_rol: this.rol,
      nombres_usuario: formValues['nombres_usuario'],
      apellidos_usuario: formValues['apellidos_usuario'],
      correo_usuario: formValues['correo_usuario'],
      telefono_usuario: formValues['telefono_usuario'],
      pais_usuario: formValues['pais_usuario'],
      fecha_de_nacimiento_usuario: formValues['fecha_de_nacimiento_usuario'],
      clave_usuario: formValues['clave_usuario'],
      subdominio_empresa: null,
      es_empresa: 'No',
    };

    request['subdominio_empresa'] = 'https://demo.infoverses.com';
    request['es_empresa'] = 'Si';
    request['id_empresa_perteneciente'] =
      '016bec7a-b55c-4665-9374-82766db41df3';

    /* if (localStorage.getItem('loginFromDemo') == 'true') {
    } */

    this.svUsuario.register(request).subscribe(
      (data) => {
        if (data.status == 'success') {
          this.alertsService.showSnackBar('Ya puedes iniciar sesión...', 3000);
          // this.dialogRef.close();

          this.showLogin = true;
          this.showRegister = false;

          /* this.showCompany = true;
          this.showRegister = false; */

          /* this.dialogRef.close();
          window.location.href = 'auth/home'; */

          this.id_usuario = data.result.id_usuario;

          //this.automaticLogin(formValues['correo_usuario'],formValues['clave_usuario'])

          this.automaticLogin(
            formValues['correo_usuario'],
            formValues['clave_usuario']
          );
        } else {
          Swal.fire('Crear cuenta', data['message'], 'warning');
        }
      },
      (err) => {
        Swal.fire(
          'Error al crear cuenta',
          'Algo salió mal al intentar registrar el usuario, intentelo más tarde',
          'error'
        );
      }
    );
  }

  /* ****************************** ADD COMPANY IN REGISTER *********************************** */
  /*  addCompany(formValues) {

    const request = {
      id_usuario: this.id_usuario,
      nombre_empresa_usuario: formValues['nombre_empresa_usuario'] || '',
      telefono_empresa_usuario: formValues['telefono_empresa_usuario'] || '',
    };

    request[
      'subdominio_empresa_usuario'
    ] = `${formValues['subdominio_empresa_usuario']}.infoverses.com`;

    request['correo_empresa_usuario'] = formValues['correo_empresa_usuario'];

    let subdominio = request['subdominio_empresa_usuario'];

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    let subdminio_data = {
      id_usuario_subdominio: this.id_usuario,
      nombre_subdominio: subdominio,
      fecha_pago_subdominio: mm + '/' + dd + '/' + yyyy,
      cuenta_activa_subdominio: '1',
    };

    this.svSubdominios.addDomain(subdminio_data).subscribe((resp_subd) => {
      // console.log(resp_subd)
      if (resp_subd['status'] === 'success') {
        this.svUsuario.addCompany(request).subscribe(
          (resp_c) => {
            // console.log(resp_c)

            if (resp_c.status == 'success') {
              let data_i = {
                es_empresa: 1,
                id_usuario: this.id_usuario,
                id_empresa_perteneciente:
                  resp_c['result']['id_empresa_usuario'],
                subdominio_empresa: request['subdominio_empresa_usuario'],
              };
              this.svUsuario.updateIsCompany(data_i).subscribe((resp_i) => {
                // console.log(resp_i)
                this.alertsService.showSnackBar('Datos actualizados!', 3000);
                if (resp_i.status == 'success') {
                  Swal.fire(
                    'Operación exitosa!',
                    'Usuario agregado de manera exitosa',
                    'success'
                  );
                  this.dialogRef.close();
                  window.location.href = 'auth/home';
                } else {
                  Swal.fire('Crear empresa', resp_i['errorMessage'], 'warning');
                }
              });
            } else {
              Swal.fire('Crear empresa', resp_c['errorMessage'], 'warning');
            }
          },
          (err) => {
            Swal.fire(
              'Crear empresa',
              'Algo salió mal al intentar crear la empresa, contacta al administrador',
              'error'
            );
          }
        );
      }
    });
  }
 */

  automaticLogin(correo, clave) {
    this.verifyingLogin = true;

    const request = {
      correo_usuario: correo,
      clave_usuario: clave,
    };

    this.authService.login(request).subscribe(
      (data) => {
        if (data.status == 'success') {
          localStorage.setItem(
            Constants.ls.user,
            btoa(JSON.stringify(data['result']['user_data']))
          );
          localStorage.setItem(
            Constants.ls.at,
            btoa(JSON.stringify(data['result']['token']))
          );

          this.svSubdominios.updateToken(
            btoa(JSON.stringify(data['result']['token']))
          );
          this.svUsuario.updateToken(
            btoa(JSON.stringify(data['result']['token']))
          );

          setTimeout(() => {
            this.verifyingLogin = false;
          }, 1000);
          this.alertsService.showSnackBar('Bienvenido al sistema...', 3000);

          this.verifyingLogin = false;
        } else {
          Swal.fire('Error: Datos incorrectos', data.message, 'error');
        }
      },
      (err) => {
        this.verifyingLogin = false;
        Swal.fire(
          'Error: Inicio de sesión',
          'Algo salió mal al intentar iniciar sesión, intentelo más tarde',
          'error'
        );
      }
    );
  }

  setDataInStorage(data: any, token: any): any {
    localStorage.setItem(Constants.ls.user, btoa(JSON.stringify(data)));
    const now = Date.now();
    // Add 10 mins in miliseconds;
    const expTime = now + 600000;
    localStorage.setItem(
      Constants.ls.session,
      JSON.stringify({ exp: expTime, tk: token.token_uid })
    );
  }
  getSelection(selection) {
    if (selection == 'company') {
      this.showCompanyFields = true;
      return;
    }
    this.showCompanyFields = false;
  }
  getOptionSeleted(option) {
    this.activeOption = option;

    if (option == 'login') {
      this.showLogin = true;
      this.showRegister = false;
    }
    if (option == 'register') {
      this.showRegister = true;
      this.showLogin = false;
    }
  }
}
